import * as actions from "./exceptions.actions";
import { ActionType, createReducer } from "typesafe-actions";
import {
    cancelExceptionUpdate,
    createSchedulerRuleException,
    deleteSchedulerRuleException,
    editExceptionRule,
    fetchSchedulerRuleExceptions,
    updateSchedulerRuleException,
} from "./exceptions.actions";
import { resetApiError } from "store/features/general";

type EmailSchedulerExceptionsAction = ActionType<typeof actions>;

export type EmailSchedulerExceptionsInitialState = Readonly<{
    isProcessing: boolean;
    isDeleting: boolean;
    isSubmitted: boolean;
    hasError: boolean;
    properties: {
        isEdited: boolean;
        id?: string;
    };
}>;

export const emailSchedulerExceptionsInitialState: EmailSchedulerExceptionsInitialState = {
    isProcessing: false,
    isDeleting: false,
    isSubmitted: false,
    hasError: false,
    properties: {
        isEdited: false,
    },
};

export const emailSchedulerExceptionsReducer = createReducer<
    EmailSchedulerExceptionsInitialState,
    EmailSchedulerExceptionsAction
>(emailSchedulerExceptionsInitialState)
    .handleAction([createSchedulerRuleException.request, updateSchedulerRuleException.request], (state) => {
        return {
            ...state,
            isProcessing: true,
        };
    })
    .handleAction([createSchedulerRuleException.success, updateSchedulerRuleException.success], (state) => {
        return {
            ...state,
            isProcessing: false,
            isSubmitted: true,
        };
    })
    // TODO: find a better way to reset this status
    .handleAction(fetchSchedulerRuleExceptions.success as never, (state) => {
        return {
            ...state,
            isSubmitted: false,
        };
    })
    .handleAction(
        [
            createSchedulerRuleException.failure,
            deleteSchedulerRuleException.failure,
            updateSchedulerRuleException.failure,
        ],
        (state) => {
            return {
                ...state,
                isDeleting: false,
                isProcessing: false,
                isSubmitted: false,
                hasError: true,
            };
        }
    )
    .handleAction(deleteSchedulerRuleException.request, (state) => {
        return {
            ...state,
            isDeleting: true,
        };
    })
    .handleAction(deleteSchedulerRuleException.success as never, (state) => {
        return {
            ...state,
            isDeleting: false,
        };
    })
    .handleAction(editExceptionRule, (state, action) => {
        return {
            ...state,
            properties: {
                id: action.payload,
                isEdited: true,
            },
        };
    })
    .handleAction(cancelExceptionUpdate, () => {
        return emailSchedulerExceptionsInitialState;
    })
    .handleAction(resetApiError as never, (state) => {
        return {
            ...state,
            hasError: false,
        };
    });
